import { PageWrapper, useLayout } from '@approvalmax/ui/src/components';
import { hocs as pageHocs } from 'modules/page';
import { memo } from 'react';
import { Helmet } from 'react-helmet';
import { ComponentErrorBoundary } from 'shared/components';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { pageConfig } from './config';
import { PageContent } from './resources/components';
import { useBreadcrumbs } from './resources/hooks/useBreadcrumbs';
import { messages } from './resources/messages';

const Page = memo(() => {
    useLayout({ hasHeader: true, hasDrawer: true });
    useBreadcrumbs();

    const company = useCompanyBasedOnUrl();

    return (
        <PageWrapper color='midnight30'>
            <Helmet
                title={messages.title({
                    companyName: company?.displayName,
                })}
            />

            <PageWrapper.Content>
                <ComponentErrorBoundary>
                    <PageContent />
                </ComponentErrorBoundary>
            </PageWrapper.Content>
        </PageWrapper>
    );
});

export default pageHocs.withProtected({ Page, roles: pageConfig.access });
